import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Breadcrumbs as MuiBreadcrumbs, Grid } from "@mui/material";
import { spacing } from "@mui/system";

import CustomDataGrid from "./components/datagrid";
import useDistrict from "../../../hooks/useDistrict";
import useTaluk from "../../../hooks/useTaluk";
import useCity from "../../../hooks/useCity";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp } from "../../../utils/common";
import Upload from "./components/Upload";

function DataGridPage() {
  const { getAllCity, states, paging, isLoading, downloadFile } = useCity();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openDialog } = useDialog();
  console.log(useCity(), "paging");

  const currentPayload = {
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "cityName",
        sort: "ASC",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getAllCity(payload);
  };
  const refreshPage = async () => {
    setPayload(currentPayload);
  };

  const onPageChange = (page) => {
    console.log(page, "pagepage");
    const pagination = {
      pageNumber: page == 0 ? 1 : page + 1,
      pageSize: payload.pagination.pageSize,
    };
    setPayload((prev) => ({ ...prev, pagination }));
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  const addCity = () => {
    navigate("/masters/city/add");
  };
  const editCity = (id) => {
    navigate("/masters/city/edit", { state: { id: id } });
  };
  const exportFile = async (fileType) => {
    await downloadFile(fileType, payload);
  };
  const openDownloadDialog = () => {
    return openDialog("upload_city", "Upload City", <Upload key={getTimeStamp()} />);
  };

  const handleSortModelChange = (newModel) => {
    //console.log(newModel, "newModel");
    if (newModel.length != 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <CustomDataGrid
            trans={t}
            addPage={addCity}
            editPage={editCity}
            refreshPage={refreshPage}
            downloadFile={exportFile}
            openDownloadDialog={openDownloadDialog}
            id="cityId"
            data={states ? states : []}
            rowCount={paging.totalNumberOfRecords}
            paging={{
              page: paging.pageNumber,
              pageSize: paging.pageSize,
            }}
            onPageChange={onPageChange}
            isLoading={isLoading}
            sortModel={sortModel}
            handleSortModelChange={handleSortModelChange}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default DataGridPage;
